var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.888 10.808l3.768-4.32H.224V5.096h15.408L11.888.8h1.608l4.44 4.992-4.44 5.016h-1.608z",
    fill: "#141414"
  })));
}

var MemoSvgArrowLarge = /*#__PURE__*/React.memo(SvgArrowLarge);
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDE4IDExIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTEuODg4IDEwLjgwOEwxNS42NTYgNi40ODhIMC4yMjRWNS4wOTZIMTUuNjMyTDExLjg4OCAwLjhIMTMuNDk2TDE3LjkzNiA1Ljc5MkwxMy40OTYgMTAuODA4SDExLjg4OFoiIGZpbGw9IiMxNDE0MTQiLz4KPC9zdmc+Cg==";
export { MemoSvgArrowLarge as ReactComponent };